import {
    DOCUMENT_UPLOAD_FIELDS as DocumentUploadFieldsType,
    DocumentLink,
    ParagraphListTypes,
    RequiredFormFields,
    TradeSubTypeId,
    TradeTypeId,
} from '../types';

export const US_STATE_OPTIONS = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
];

export const TAX_ID_TYPE_OPTIONS = [
    { value: 'EIN', label: 'EIN' },
    { value: 'SSN', label: 'SSN' },
];

const SECRETARY_OF_STATE_SEARCH_LINKS: DocumentLink[] = [
    {
        label: 'Alabama',
        url: 'https://arc-sos.state.al.us/CGI/CORPNAME.MBR/INPUT',
    },
    {
        label: 'Alaska',
        url: 'https://www.commerce.alaska.gov/cbp/main/search/Entities',
    },
    { label: 'Arizona', url: 'https://apps.azsos.gov/apps/tntp/se.html' },
    {
        label: 'Arkansas',
        url: 'https://www.ark.org/corp-search/index.php/corps',
    },
    {
        label: 'California',
        url: 'https://bizfileonline.sos.ca.gov/search/business',
    },
    {
        label: 'Colorado',
        url: 'https://www.sos.state.co.us/ucc/pages/biz/bizSearch.xhtml',
    },
    {
        label: 'Connecticut',
        url: 'https://service.ct.gov/business/s/onlinebusinesssearch?language=en_US',
    },
    {
        label: 'Delaware',
        url: 'https://icis.corp.delaware.gov/ecorp/entitysearch/namesearch.aspx',
    },
    {
        label: 'Florida',
        url: 'https://search.sunbiz.org/Inquiry/CorporationSearch/ByName',
    },
    { label: 'Georgia', url: 'https://ecorp.sos.ga.gov/businesssearch' },
    { label: 'Hawaii', url: 'https://hbe.dcca.hawaii.gov/' },
    { label: 'Idaho', url: 'https://sosbiz.idaho.gov/search/business' },
    { label: 'Illinois', url: 'https://apps.ilsos.gov/businessentitysearch/' },
    {
        label: 'Indiana',
        url: 'https://bsd.sos.in.gov/publicbusinesssearch',
    },
    {
        label: 'Iowa',
        url: 'https://sos.iowa.gov/search/business/search.aspx',
    },
    {
        label: 'Kansas',
        url: 'https://www.sos.ks.gov/eforms/BusinessEntity/Search.aspx',
    },
    {
        label: 'Kentucky',
        url: 'https://sosbes.sos.ky.gov/BusSearchNProfile/search.aspx',
    },
    {
        label: 'Louisiana',
        url: 'https://coraweb.sos.la.gov/CommercialSearch/CommercialSearch.aspx',
    },
    {
        label: 'Maine',
        url: 'https://apps3.web.maine.gov/nei-sos-icrs/ICRS?MainPage=x',
    },
    {
        label: 'Maryland',
        url: 'https://egov.maryland.gov/businessexpress/entitysearch',
    },
    {
        label: 'Massachusetts',
        url: 'https://corp.sec.state.ma.us/corpweb/CorpSearch/CorpSearch.aspx',
    },
    { label: 'Michigan', url: 'https://mibusinessregistry.lara.state.mi.us/' },
    {
        label: 'Minnesota',
        url: 'https://mblsportal.sos.mn.gov/Business/Search',
    },
    {
        label: 'Mississippi',
        url: 'https://corp.sos.ms.gov/corp/portal/c/page/corpBusinessIdSearch/portal.aspx',
    },
    {
        label: 'Missouri',
        url: 'https://bsd.sos.mo.gov/BusinessEntity/BESearch.aspx?SearchType=0',
    },
    { label: 'Montana', url: 'https://biz.sosmt.gov/search/business' },
    {
        label: 'Nebraska',
        url: 'https://www.nebraska.gov/sos/corp/corpsearch.cgi?nav=search',
    },
    {
        label: 'Nevada',
        url: 'https://esos.nv.gov/EntitySearch/OnlineEntitySearch',
    },
    {
        label: 'New Hampshire',
        url: 'https://quickstart.sos.nh.gov/online/BusinessInquire',
    },
    {
        label: 'New Jersey',
        url: 'https://www.njportal.com/DOR/BusinessNameSearch/Search/BusinessName',
    },
    {
        label: 'New Mexico',
        url: 'https://enterprise.sos.nm.gov/search/business',
    },
    { label: 'New York', url: 'https://apps.dos.ny.gov/publicInquiry/' },
    {
        label: 'North Carolina',
        url: 'https://www.sosnc.gov/online_services/search/by_title/_Business_Registration',
    },
    {
        label: 'North Dakota',
        url: 'https://firststop.sos.nd.gov/search/business',
    },
    { label: 'Ohio', url: 'https://businesssearch.ohiosos.gov/' },
    {
        label: 'Oklahoma',
        url: 'https://www.sos.ok.gov/corp/corpInquiryFind.aspx',
    },
    {
        label: 'Oregon',
        url: 'https://sos.oregon.gov/business/Pages/find.aspx',
    },
    {
        label: 'Pennsylvania',
        url: 'https://file.dos.pa.gov/search/business',
    },
    {
        label: 'Rhode Island',
        url: 'https://business.sos.ri.gov/corpweb/corpsearch/corpsearch.aspx',
    },
    {
        label: 'South Carolina',
        url: 'https://businessfilings.sc.gov/BusinessFiling/Entity/Search',
    },
    {
        label: 'South Dakota',
        url: 'https://sosenterprise.sd.gov/BusinessServices/Business/FilingSearch.aspx',
    },
    {
        label: 'Tennessee',
        url: 'https://tncab.tnsos.gov/business-entity-search',
    },
    {
        label: 'Texas',
        url: 'https://www.sos.state.tx.us/corp/sosda/index.shtml',
    },
    {
        label: 'Utah',
        url: 'https://businessregistration.utah.gov/EntitySearch/OnlineEntitySearch',
    },
    {
        label: 'Vermont',
        url: 'https://bizfilings.vermont.gov/business/businesssearch',
    },
    {
        label: 'Virginia',
        url: 'https://cis.scc.virginia.gov/EntitySearch/Index',
    },
    { label: 'Washington', url: 'https://ccfs.sos.wa.gov/#/' },
    {
        label: 'West Virginia',
        url: 'https://apps.wv.gov/sos/businessentitysearch/',
    },
    {
        label: 'Wisconsin',
        url: 'https://apps.dfi.wi.gov/apps/CorpSearch/Search.aspx',
    },
    {
        label: 'Wyoming',
        url: 'https://wyobiz.wyo.gov/Business/FilingSearch.aspx',
    },
];

export const DOCUMENT_UPLOAD_FIELDS: DocumentUploadFieldsType = {
    certificateOfLiability: {
        label: 'Certificate of Insurance',
        paragraphContent: {
            intro: 'Upload your COI document. Insurance Requirements:',
            listType: ParagraphListTypes.UNORDERED,
            listItems: [
                'General Liability: $1 Million',
                'Aggregate: $2 Million',
                "Certificate Holder: Motili's Name and Denver Address",
            ],
            outro: 'Confirm the effective date and expiration date of your certificate before saving.',
        },
        requiredFormFields: [
            RequiredFormFields.effectiveDate,
            RequiredFormFields.expirationDate,
        ],
    },
    epaCertification: {
        label: 'EPA Certification',
        paragraphText:
            'Provide a copy of your card. Acceptable certifications are "Type II" or "Universal". Confirm the issue date of your certification before saving.',
        requiredFormFields: [RequiredFormFields.issueDate],
    },
    secretaryOfStateRegistration: {
        label: 'Secretary of State Registration Certification',
        paragraphContent: {
            intro: 'Upload your Secretary of State Registration Certification or Screenshot. Information that must be included is business name and state of formation.',
            listType: ParagraphListTypes.ORDERED,
            listItems: [
                'Click on respective state link.',
                'Enter the full business name to search records.',
                'After locating your business, click the link to view its details.',
                'Capture screenshot or download the certificate to then upload here.',
            ],
            outro: 'Business name on W-9 must match this exactly. This is required for payment of work performed.',
        },
        links: SECRETARY_OF_STATE_SEARCH_LINKS,
        requiredFormFields: [],
    },
    w9: {
        label: 'W-9 Tax Form',
        paragraphContent: {
            intro: 'Upload your W-9 form. Please note your form must have the following:',
            listType: ParagraphListTypes.ORDERED,
            listItems: [
                'Business name must match Secretary of State Registration business name',
                'Company name must be listed on line 1, and EIN provided',
                "If Sole Proprietorship: Please list the business owner's name on line 1 and provide the associated social security number",
            ],
            outro: 'Confirm your Tax Identification Number and type before saving.',
        },
        requiredFormFields: [
            RequiredFormFields.taxIdType,
            RequiredFormFields.taxIdNumber,
        ],
    },
    tradeLicenses: {
        label: 'Trade Licenses',
        paragraphText:
            'Upload your Trade License. Confirm the effective date and expiration date of your license before saving.',
        requiredFormFields: [
            RequiredFormFields.tradeType,
            RequiredFormFields.effectiveDate,
            RequiredFormFields.expirationDate,
        ],
    },
    taxSalesCertificate: {
        label: 'Tax Sales Certificate',
        paragraphText:
            'Upload your Tax Sale Certificate(s). Confirm the state of your certificate before saving.',
        requiredFormFields: [RequiredFormFields.state],
    },
};

export const defaultTradeType = [
    {
        type: 'HVAC',
        subCategories: ['Residential'],
    },
];

export const corporationTypes = [
    {
        value: 'C-CORP',
        label: 'Corporation (C-Corp)',
    },
    {
        value: 'LLC',
        label: 'Limited Liability Company (LLC)',
    },
    {
        value: 'PARTNERSHIP',
        label: 'Partnership',
    },
    {
        value: 'S-CORP',
        label: 'Corporation (S-Corp)',
    },
    {
        value: 'SOLE_PROPRIETORSHIP',
        label: 'Sole Proprietorship',
    },
    {
        value: 'OTHER',
        label: 'Other Business Type',
    },
];

export const TRADE_TYPE_OPTIONS = [
    {
        value: 'HVAC - RESIDENTIAL',
        label: 'HVAC - Residential',
        tradeTypeId: TradeTypeId.HVAC,
        tradeSubTypeId: TradeSubTypeId.RESIDENTIAL,
    },
    {
        value: 'HVAC - COMMERCIAL',
        label: 'HVAC - Commercial',
        tradeTypeId: TradeTypeId.HVAC,
        tradeSubTypeId: TradeSubTypeId.COMMERCIAL,
    },
    {
        value: 'ELECTRICAL - RESIDENTIAL',
        label: 'Electrical - Residential',
        tradeTypeId: TradeTypeId.ELECTRICAL,
        tradeSubTypeId: TradeSubTypeId.RESIDENTIAL,
    },
    {
        value: 'ELECTRICAL - COMMERCIAL',
        label: 'Electrical - Commercial',
        tradeTypeId: TradeTypeId.ELECTRICAL,
        tradeSubTypeId: TradeSubTypeId.COMMERCIAL,
    },
    {
        value: 'PLUMBING - RESIDENTIAL',
        label: 'Plumbing - Residential',
        tradeTypeId: TradeTypeId.PLUMBING,
        tradeSubTypeId: TradeSubTypeId.RESIDENTIAL,
    },
    {
        value: 'PLUMBING - COMMERCIAL',
        label: 'Plumbing - Commercial',
        tradeTypeId: TradeTypeId.PLUMBING,
        tradeSubTypeId: TradeSubTypeId.COMMERCIAL,
    },
    {
        value: 'PLUMBING - WATER HEATER',
        label: 'Plumbing - Water Heater',
        tradeTypeId: TradeTypeId.PLUMBING,
        tradeSubTypeId: TradeSubTypeId.WATER_HEATER,
    },
];

export enum PARTS_EQUIPMENT_ORDERING_OPTIONS {
    FOR_MY_COMPANY = 'forMyCompany',
    ON_BEHALF_OF_CLIENT = 'onBehalfOfClient',
}
